import React from 'react';
import { Apps, QuestionFull } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box, Typography, useTheme } from '@mui/material';
import { AvTooltip } from './AvTooltip';

export const CrossAppHeader: React.FC = () => {
  const theme = useTheme();
  return (
    <Box sx={{ ...flex.center, gap: 1, backgroundColor: theme.palette.warning.main, paddingY: 1 }}>
      <Apps style={{ width: 24, height: 24, color: theme.palette.white.main as string }} />
      <Typography
        variant="h3"
        sx={{
          color: theme.palette.white.main,
          margin: 0,
          fontSize: '22px',
          fontWeight: 700,
        }}>
        Cross App Change
      </Typography>
      <AvTooltip title="Cross-app changes may affect multiple applications installed on this account" variant="message" color="white">
        <Box sx={{ ...flex.justifyEndCenter }}>
          <QuestionFull style={iconSize(24)} />
        </Box>
      </AvTooltip>
    </Box>
  );
};
